import { Col, Row } from "react-bootstrap";
import PricingCard from "../../components/PricingCard";
import ActivePlanDetails from "./components/ActivePlanDetails";
import { useGetUserProfileQuery } from "../../features/users/usersApi";
import { getActiveSubscription } from "./utils/subscriptionHelpers";

const Plans = () => {
  const { data: profileData, isLoading } = useGetUserProfileQuery(undefined);
  const activeSubscription = getActiveSubscription(
    profileData?.data?.organization?.subscriptions
  );

  return (
    <Row className="justify-content-center">
      <Row className="col-12">
        <div className="text-center my-1">
          <h3 className="mb-2 settings-header">
            {activeSubscription ? "Your plan" : "Our plans"}
          </h3>
          <p className="text-muted w-50 m-auto">
            {activeSubscription
              ? "Review your active subscription details and included features."
              : "We have plans and prices that fit your business perfectly. Make your client site a success with our products."}
          </p>
        </div>
      </Row>

      <Row className="col-12">
        {isLoading ? (
          <Col lg={12}>
            <div className="active-plan-details active-plan-details--loading">
              Loading plan details...
            </div>
          </Col>
        ) : activeSubscription ? (
          <Col lg={12}>
            <ActivePlanDetails subscription={activeSubscription} />
          </Col>
        ) : (
          <PricingCard containerClass={"flex items-stretch my-3"} />
        )}
      </Row>

      {!activeSubscription ? (
        <Row>
          <Col lg={"12"}>
            <div className="italic font-12 text-black">
              <p>
                *Trial Plan - By default you are signed up on the Growth plan for
                free for 90 days, You won&apos;t be charged for the plan unless you
                choose to upgrade, The trial will automatically cancel on the
                trial end date. If you do not upgrade to the Growth plan before
                the end of the trial period, you will be moved to the Starter Plan
                and you will lose access to the Growth Plan features.
              </p>
              <p>
                *Team Management - Scale Plan includes 3 team members, and
                Enterprise Plan covers 5. Additional members are $20/month each.
              </p>
              <p>
                *Shipping and taxes are based on actuals, and Processing Fee is
                fixed rate of 10%.
              </p>
              <p>
                *International shipping is charged at cost. Local delivery may be
                available. Contact us for eligible locations.
              </p>
              <p>
                *Gain Referral Gift credits everytime you refer someone to
                Memorique as a thank you!
              </p>
            </div>
          </Col>
        </Row>
      ) : null}
    </Row>
  );
};

export default Plans;
